import { Sidebar } from "primereact/sidebar";
import { useEffect, useRef, useState } from "react";
import { IoMdSettings } from "react-icons/io";
import { Outlet } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { InputSwitch } from "primereact/inputswitch";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { createApiClient } from "@/lib/Requests";

export const PreApplicationLayout = () => {
  var diagnosticsEnabled: Boolean = (document.querySelector('meta[data-enable-diagnostics]') as HTMLMetaElement)?.dataset?.enableDiagnostics == "true";
  const client = createApiClient({ timeout: 60000 });
  const [displayDiagnostics, setDisplayDiagnostics] = useState(false);
  const [quickIdle, setQuickIdle] = useState(sessionStorage.getItem("quickIdle") == "true" ? true : false);
  const [applicantAPIStatus, setApplicantAPIStatus] = useState(0);
  const [dealAPIStatus, setDealAPIStatus] = useState(0);
  const [IRSStatus, setIRSStatus] = useState(0);
  const [adminAPIStatus, setAdminAPIStatus] = useState(0);
  const [robStatus, setRobStatus] = useState(0);
  const buildInfoTag = (document.querySelector('meta[data-version]') as HTMLElement);
  const buildNumber = buildInfoTag?.dataset?.version;
  const identityVerification = buildInfoTag?.dataset?.enableAlloy == "true" ? "Enabled" : "Disabled";
  const phoneVerification = buildInfoTag?.dataset?.enableTwilio == "true" ? "Enabled" : "Disabled";
  const tmxId = buildInfoTag?.dataset?.tmxOrgid;
  const tmxStatus = buildInfoTag?.dataset?.enableTmx == "true" ? "Enabled" : "Disabled";
  const versionToast = useRef<Toast>(null);

  const copyVersionNumberToClipboard = () => {
    navigator.clipboard.writeText(buildNumber ? buildNumber : "");
    versionToast.current?.show({ severity: 'success', summary: 'Copied ' + buildNumber + ' to clipboard.', life: 1000 });
  }

  const toggleIdleSetting = (quickIdle: boolean) => {
    setQuickIdle(quickIdle);
    if (quickIdle) {
      sessionStorage.setItem("quickIdle", "true");
    } else {
      sessionStorage.removeItem("quickIdle");
    }
    const timeout = setTimeout(() => {
      window.location.reload();
    }, 750)
    return () => clearTimeout(timeout)
  }

  useEffect(() => {
    if (displayDiagnostics) {
      setApplicantAPIStatus(0);
      setDealAPIStatus(0);
      setIRSStatus(0);
      setAdminAPIStatus(0);
      setRobStatus(0);
      const timeout = setTimeout(() => {
        client.apiHeartbeatApplicantmanagement().then(async result => {
          if (result && result.status == "Healthy"){
            setApplicantAPIStatus(1);
          }else{
            setApplicantAPIStatus(2);
          }
        }).catch((error) => {
          setApplicantAPIStatus(2);
        });
        client.apiHeartbeatMortgagedeals().then(async result => {
          if (result && result.status == "Healthy"){
            setDealAPIStatus(1);
          }else{
            setDealAPIStatus(2);
          }
        }).catch((error) => {
          setDealAPIStatus(2);
        });
        client.apiHeartbeatIrs().then(async result => {
          if (result && result.timestamp){
            setIRSStatus(1);
          }else{
            setIRSStatus(2);
          }
        }).catch((error) => {
          setIRSStatus(2);
        });
        client.apiHeartbeatAdmin().then(async result => {
          if (result && result.status == "Healthy"){
            setAdminAPIStatus(1);
          }else{
            setAdminAPIStatus(2);
          }
        }).catch((error) => {
          setAdminAPIStatus(2);
        });
        client.apiHeartbeatRob().then(async result => {
          if (result && result.status == "Healthy"){
            setRobStatus(1);
          }else{
            setRobStatus(2);
          }
        }).catch((error) => {
          setRobStatus(2);
        });
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [displayDiagnostics]);

  return (
    <>
      <nav id="topbar">
        <div className="grid grid-cols-4 grid-flow-col gap-4 mt-2">
          <div className="sm:hidden flex">
          </div>
          <div className="mt-2 max-md:col-span-3 col-span-1 col-1 ml-5">
            <img
              src="assets/Meridian_Logo_Blue.svg"
              alt="Meridian"
              width={150}
              height={25}
            />
          </div>
          <div className="max-sm:hidden absolute mt-3 right-32 max-lg:right-0 max-md:right-3 flex">
            {diagnosticsEnabled && <IoMdSettings className="cursor-pointer" style={{ fontSize: 28, color: 'var(--brand-blue)' }} onClick={() => { setDisplayDiagnostics(true) }} />}
          </div>
        </div>
        <hr />
      </nav>
      <Toast ref={versionToast} />
      <Sidebar header={<h2 style={{ marginBottom: 0 }}>DTM Diagnostics</h2>} visible={displayDiagnostics} position="right" onHide={() => setDisplayDiagnostics(false)}>
        <p className="sub-heading mt-5 cursor-pointer" style={{ fontSize: 16 }} onClick={() => { copyVersionNumberToClipboard() }}><b>Build Number: </b>{buildNumber}</p>
        <p className="sub-heading mt-5" style={{ fontSize: 16 }}><b>ID Verification: </b>{identityVerification}</p>
        <p className="sub-heading" style={{ fontSize: 16 }}><b>Twilio Phone Verification: </b>{phoneVerification}</p>
        <p className="sub-heading mt-5" style={{ fontSize: 16 }}><b>ThreatMatrix: </b>{tmxStatus}</p>
        <p className="sub-heading" style={{ fontSize: 16 }}><b>ThreatMatrix ID: </b>{tmxId}</p>
        <div className="flex mt-5">
          <p className="sub-heading"><b>Enable 30 Second Idle</b></p>
          <InputSwitch checked={quickIdle} onChange={(e) => toggleIdleSetting(e.value)} className="ml-3" />
        </div>

        <p className="sub-heading mt-5 flex flex-row justify-between" style={{ fontSize: 16 }}><b>Applicant API Status: </b>
          <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(applicantAPIStatus == 0 ? "" : "hidden")} />
          <img src={applicantAPIStatus == 1 ? "assets/completed.svg" : "assets/warning-icon.svg"} className={clsx(applicantAPIStatus != 0 ? "mr-1 ml-3" : "hidden")} alt="complete" />
        </p>
        <p className="sub-heading mt-2 flex flex-row justify-between" style={{ fontSize: 16 }}><b>Mortgage Deals API Status: </b>
          <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(dealAPIStatus == 0 ? "" : "hidden")} />
          <img src={dealAPIStatus == 1 ? "assets/completed.svg" : "assets/warning-icon.svg"} className={clsx(dealAPIStatus != 0 ? "mr-1 ml-3" : "hidden")} alt="complete" />
        </p>
        <p className="sub-heading mt-2 flex flex-row justify-between" style={{ fontSize: 16 }}><b>Identity Request Service Status: </b>
          <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(IRSStatus == 0 ? "" : "hidden")} />
          <img src={IRSStatus == 1 ? "assets/completed.svg" : "assets/warning-icon.svg"} className={clsx(IRSStatus != 0 ? "mr-1 ml-3" : "hidden")} alt="complete" />
        </p>
        <p className="sub-heading mt-2 flex flex-row justify-between" style={{ fontSize: 16 }}><b>Admin API Status: </b>
          <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(adminAPIStatus == 0 ? "" : "hidden")} />
          <img src={adminAPIStatus == 1 ? "assets/completed.svg" : "assets/warning-icon.svg"} className={clsx(adminAPIStatus != 0 ? "mr-1 ml-3" : "hidden")} alt="complete" />
        </p>
        <p className="sub-heading mt-2 flex flex-row justify-between" style={{ fontSize: 16 }}><b>ROB Support Service Status: </b>
          <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(robStatus == 0 ? "" : "hidden")} />
          <img src={robStatus == 1 ? "assets/completed.svg" : "assets/warning-icon.svg"} className={clsx(robStatus != 0 ? "mr-1 ml-3" : "hidden")} alt="complete" />
        </p>
      </Sidebar>
      <Outlet />
    </>
  )
}
